import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { LeafDivider } from '@cigna/leaf-web/lib/wc';
import '@cigna/leaf-web/lib/wc/components/divider/divider';

@Component({
  selector: 'cigna-leaf-divider',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-divider [variant]="variant" [status]="status"></leaf-divider>
  `,
})
export class CignaLeafDividerComponent {
  @Input() variant: LeafDivider['variant'];
  @Input() status: LeafDivider['status'];
}
